import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const UiButtons = () => {
  const [drp_link, setdrp_link] = useState(false);
  const [drp_link1, setdrp_link1] = useState(false);
  document.title = "Buttons | Linc Quality Hub";


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="UI Elements" breadcrumbItem="Buttons" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Basic Examples</h4>
                  <p className="card-title-desc">
                    In need of a button, Replace the default modifier classes with the .btn-*
                  </p>

                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                    >
                      Primary
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                    >
                      Secondary
                    </button>
                    <button
                      type="button"
                      className="btn btn-success"
                    >
                      Success
                    </button>
                    <button
                      type="button"
                      className="btn btn-info"
                    >
                      Info
                    </button>
                    <button
                      type="button"
                      className="btn btn-warning"
                    >
                      Warning
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                    >
                      Danger
                    </button>
                    <button
                      type="button"
                      className="btn btn-light "
                    >
                      Light
                    </button>
                    <button
                      type="button"
                      className="btn btn-dark"
                    >
                      Dark
                    </button>
                    <button
                      type="button"
                      className="btn btn-link "
                    >
                      Link
                    </button>
                  </div>

                  <div className="mt-3 border">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
   <div>
      <button type="button" className="btn btn-primary">Primary</button>
      <button type="button" className="btn btn-secondary">Secondary</button>
      <button type="button" className="btn btn-success">Success</button>
      <button type="button" className="btn btn-info">Info</button>
      <button type="button" className="btn btn-warning">Warning</button>
      <button type="button" className="btn btn-danger">Danger</button>
      <button type="button" className="btn btn-light ">Light</button>
      <button type="button" className="btn btn-dark">Dark</button>
      <button type="button" className="btn btn-link ">Link</button>
    </div>
                        `}

                      </code>
                    </pre>


                  </div>

                </CardBody>
              </Card>
            </Col>

            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Outline Buttons</h4>
                  <p className="card-title-desc">
                    In need of a button, but not the hefty background colors
                    they bring? Replace the default modifier classes with the{" "}
                    <code>.btn-outline-*</code> ones to remove all background
                    images and colors on any button.
                  </p>

                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                    >
                      Primary
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                    >
                      Secondary
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-success"
                    >
                      Success
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-info"
                    >
                      Info
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-warning"
                    >
                      Warning
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                    >
                      Danger
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-dark"
                    >
                      Dark
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-light "
                    >
                      Light
                    </button>
                  </div>

                  <div className="mt-3 border">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div>
    <button type="button" className="btn btn-outline-primary">Primary</button>
    <button type="button" className="btn btn-outline-secondary">Secondary</button>
    <button type="button" className="btn btn-outline-success">Success</button>
    <button type="button" className="btn btn-outline-info">Info</button>
    <button type="button" className="btn btn-outline-warning">Warning</button>
    <button type="button" className="btn btn-outline-danger">Danger</button>
    <button type="button" className="btn btn-outline-dark">Dark</button>
    <button type="button" className="btn btn-outline-light ">Light</button>
  </div>
 `}

                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Rounded Buttons</h4>
                  <p className="card-title-desc">
                    Use class <code>.btn-rounded</code> for button round
                    border.
                  </p>
                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="btn btn-primary btn-rounded"
                    >
                      Primary
                    </button>
                    <button
                      type="button"
                      className="btn btn-light btn-rounded "
                    >
                      Light
                    </button>
                    <button
                      type="button"
                      className="btn btn-success btn-rounded"
                    >
                      Success
                    </button>
                    <button
                      type="button"
                      className="btn btn-info btn-rounded"
                    >
                      Info
                    </button>
                    <button
                      type="button"
                      className="btn btn-warning btn-rounded"
                    >
                      Warning
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger btn-rounded"
                    >
                      Danger
                    </button>
                    <button
                      type="button"
                      className="btn btn-dark btn-rounded"
                    >
                      Dark
                    </button>
                    <button
                      type="button"
                      className="btn btn-link btn-rounded "
                    >
                      Link
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-rounded"
                    >
                      Secondary
                    </button>
                  </div>

                  <div className="mt-3 border">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div>
    <button type="button" className="btn btn-primary btn-rounded">Primary</button>
    <button type="button" className="btn btn-light btn-rounded">Light</button>
    <button type="button" className="btn btn-success btn-rounded">Success</button>
    <button type="button" className="btn btn-info btn-rounded">Info</button>
    <button type="button" className="btn btn-warning btn-rounded">Warning</button>
    <button type="button" className="btn btn-danger btn-rounded">Danger</button>
    <button type="button" className="btn btn-dark btn-rounded">Dark</button>
    <button type="button" className="btn btn-link btn-rounded">Link</button>
    <button type="button" className="btn btn-secondary btn-rounded">Secondary</button>
  </div>
             `}

                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Buttons with Icon</h4>
                  <p className="card-title-desc">Add icon in button.</p>
                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                    >
                      Primary{" "}
                      <i className="ri-arrow-right-line align-middle ms-2"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-success"
                    >
                      <i className="ri-check-line align-middle me-2"></i>{" "}
                      Success
                    </button>
                    <button
                      type="button"
                      className="btn btn-warning"
                    >
                      <i className="ri-error-warning-line align-middle me-2"></i>{" "}
                      Warning
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                    >
                      <i className="ri-close-line align-middle me-2"></i>{" "}
                      Danger
                    </button>
                  </div>

                  <div className="mt-3 border">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
    <div>
      <button type="button" className="btn btn-primary">
        Primary <i className="ri-arrow-right-line align-middle ms-2"></i>
      </button>

      <button type="button" className="btn btn-success">
       <i className="ri-check-line align-middle me-2"></i> Success
      </button>

      <button type="button" className="btn btn-warning">
       <i className="ri-error-warning-line align-middle me-2"></i> Warning
      </button>

      <button type="button" className="btn btn-danger">
       <i className="ri-close-line align-middle me-2"></i> Danger
      </button>
    </div>
      `}

                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>


          {/* color Association */}
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Color Association</h4>
                  <p className="card-title-desc">
                    Update the class name based on the action performed. Example: <code>.btn-active</code>
                  </p>
                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="btn btn-active btn-rounded"
                    >
                      Active / Engaged
                    </button>
                    <button
                      type="button"
                      className="btn btn-active-not-engaged btn-rounded "
                    >
                      Active but Not Engaged
                    </button>
                    <button
                      type="button"
                      className="btn btn-inactive btn-rounded"
                    >
                      Inactive
                    </button>
                    <button
                      type="button"
                      className="btn btn-call btn-rounded"
                    >
                      Call
                    </button>
                    <button
                      type="button"
                      className="btn btn-chat btn-rounded"
                    >
                      Chat
                    </button>
                    <button
                      type="button"
                      className="btn btn-high-risk btn-rounded"
                    >
                      Hight Risk
                    </button>
                    <button
                      type="button"
                      className="btn btn-medium-risk btn-rounded"
                    >
                      Medium Risk
                    </button>
                    <button
                      type="button"
                      className="btn btn-low-risk btn-rounded "
                    >
                      Low Risk
                    </button>
                    
                  </div>

                  <div className="mt-3 border">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div className="d-flex flex-wrap gap-2">

    <button type="button" className="btn btn-active btn-rounded">
      Active / Engaged
    </button>

    <button type="button" className="btn btn-active-not-engaged btn-rounded">
      Active but Not Engaged
    </button>

    <button type="button" className="btn btn-inactive btn-rounded">
      Inactive
    </button>

    <button type="button" className="btn btn-call btn-rounded">
      Call
    </button>

    <button type="button" className="btn btn-chat btn-rounded">
      Chat
    </button>

    <button type="button" className="btn btn-high-risk btn-rounded">
      High Risk
    </button>

    <button type="button" className="btn btn-medium-risk btn-rounded">
      Medium Risk
    </button>

    <button type="button" className="btn btn-low-risk btn-rounded">
      Low Risk
    </button>

  </div>

             `}

                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title ">Color Palette</h4>
                  <p className="card-title-desc">
                  If you need any of the following colors, simply use the corresponding color name. Exaple : <code>.robin-blue, .midnight-blue</code>
                  </p>
                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="btn robin-blue"
                    >
                      Robin's Egg Blue
                    </button>
                    <button
                      type="button"
                      className="btn midnight-blue"
                    >
                      Midnight Blue

                    </button>
                    <button
                      type="button"
                      className="btn french-pass"
                    >
                      French Pass

                    </button>
                    <button
                      type="button"
                      className="btn sundown"
                    >
                      Sundown
                    </button>
                    <button
                      type="button"
                      className="btn moccasin "
                    >
                      Moccasin
                    </button>
                    <button
                      type="button"
                      className="btn columbia-blue"
                    >
                      Columbia Blue
                    </button>
                    <button
                      type="button"
                      className="btn charcoal"
                    >
                      Charcoal
                    </button>
                    <button
                      type="button"
                      className="btn nobel "
                    >
                      Nobel
                    </button>
                    <button
                      type="button"
                      className="btn silver"
                    >
                      Silver
                    </button>
                    <button
                      type="button"
                      className="btn valencia"
                    >
                      Valencia
                    </button>
                    <button
                      type="button"
                      className="btn solitude"
                    >
                      Solitude
                    </button>

                    <button
                      type="button"
                      className="btn alice-blue"
                    >
                      Alice Blue
                    </button>

                    <button
                      type="button"
                      className="btn papaya-whip"
                    >
                      Papaya Whip
                    </button>

                  
                    
                  </div>

                  <div className="mt-3 border">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
    <div className="d-flex flex-wrap gap-2">

      <button type="button" className="btn robin-blue">
        Robin's Egg Blue
      </button>

      <button type="button" className="btn midnight-blue">
        Midnight Blue
      </button>

      <button type="button" className="btn french-pass">
        French Pass
      </button>

      <button type="button" className="btn sundown">
        Sundown
      </button>

      <button type="button" className="btn moccasin">
        Moccasin
      </button>

      <button type="button" className="btn columbia-blue">
        Columbia Blue
      </button>

      <button type="button" className="btn charcoal">
        Charcoal
      </button>

      <button type="button" className="btn nobel">
        Nobel
      </button>

      <button type="button" className="btn silver">
        Silver
      </button>

      <button type="button" className="btn valencia">
        Valencia
      </button>

      <button type="button" className="btn solitude">
        Solitude
      </button>

      <button type="button" className="btn alice-blue">
        Alice Blue
      </button>

      <button type="button" className="btn papaya-whip">
        Papaya Whip
      </button>

  </div>

             `}

                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>
            

            <Col xl={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title ">Gradient Color Palette</h4>
                  <p className="card-title-desc">
                  If you need any of the following gradient colors, simply use the corresponding gradient color name. Exaple : <code>.lavender-gradient, .minty-gradient</code>
                  </p>
                  <div className="d-flex flex-wrap gap-3">
                    <div className="sky-gradient p-5">
                      Sky Gradient
                    </div>

                    <div className=" minty-gradient p-5">
                      Minty gradient
                      </div>

                      <div className="peachy-gradient p-5">
                       Peachy Gradient
                      </div>

                      <div className="lavender-gradient p-5">
                      Lavender Gradient
                      </div>

                      <div className="light-blue-gradient p-5">
                      Light Blue Gradient
                      </div>

                      <div className="blush-gradient p-5">
                      Blush Gradient
                      </div>

                      <div className="peach-blossom-gradient p-5">
                      Peach Blossom Gradientt
                      </div>

                      <div className="sky-blue-gradient p-5">
                      Sky Blue Gradient
                      </div>

                      <div className="cotton-candy-gradient p-5">
                      Cotton Candy Gradient
                      </div>
                    
                      <div className="soft-blue-gradient p-5">
                      Soft Blue Gradient
                      </div>
                      <div className="coral-peach-gradient p-5">
                      Coral Peach Gradient
                      </div>
                      
                  </div>

                  <div className="mt-3 border">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
   <div className="d-flex flex-wrap gap-3">
      <div className="sky-gradient p-5">
        Sky Gradient
      </div>

      <div className="minty-gradient p-5">
        Minty Gradient
      </div>

      <div className="peachy-gradient p-5">
        Peachy Gradient
      </div>

      <div className="lavender-gradient p-5">
        Lavender Gradient
      </div>

      <div className="light-blue-gradient p-5">
        Light Blue Gradient
      </div>

      <div className="blush-gradient p-5">
        Blush Gradient
      </div>

      <div className="peach-blossom-gradient p-5">
        Peach Blossom Gradient
      </div>

      <div className="sky-blue-gradient p-5">
        Sky Blue Gradient
      </div>

      <div className="cotton-candy-gradient p-5">
        Cotton Candy Gradient
      </div>

      <div className="soft-blue-gradient p-5">
        Soft Blue Gradient
      </div>

      <div className="coral-peach-gradient p-5">
        Coral Peach Gradient
      </div>
  </div>


             `}

                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>

          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Button Tags</h4>
                  <p className="card-title-desc">
                    The <code>.btn</code> {' '}
                    classes are designed to be used with the{" "}
                    <code>&lt;button&gt;</code> element. However, you can also
                    use these classes on <code>&lt;a&gt;</code> or{" "}
                    <code>&lt;input&gt;</code> elements (though some browsers
                    may apply a slightly different rendering).
                  </p>

                  <div className="d-flex flex-wrap gap-2">
                    <Link to="#" className="btn btn-success" role="button">
                      Link
                    </Link>
                    <button className="btn btn-primary" type="submit">
                      Button
                    </button>
                    <input
                      className="btn btn-info"
                      type="button"
                      value="Input"
                    />
                    <input
                      className="btn btn-warning"
                      type="submit"
                      value="Submit"
                    />
                    <input
                      className="btn btn-danger"
                      type="reset"
                      value="Reset"
                    />
                  </div>

                  <div className="mt-3 border">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
    <div>
      <Link to="#" className="btn btn-success" role="button">Link</Link>
      <button className="btn btn-primary" type="submit">Button</button>
      <input className="btn btn-info" type="button" value="Input" />
      <input className="btn btn-warning" type="submit" value="Submit" />
      <input className="btn btn-danger" type="reset" value="Reset" />
    </div>
             `}

                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Button Sizes</h4>
                  <p className="card-title-desc">
                    Fancy larger or smaller buttons? Add {" "}
                    <code>.btn-lg</code> or <code>.btn-sm</code> for
                    additional sizes.
                  </p>

                  <div className="d-flex flex-wrap gap-2 align-items-center">
                    <button
                      type="button"
                      className="btn btn-info btn-lg"
                    >
                      Large Button
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-lg"
                    >
                      Large Button
                    </button>
                    <button
                      type="button"
                      className="btn btn-info btn-sm"
                    >
                      Small Button
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                    >
                      Small Button
                    </button>
                  </div>

                  <div className="mt-3 border">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
    <div className="d-flex flex-wrap gap-2 align-items-center">
      <button type="button" className="btn btn-info btn-lg">Large Button</button>
      <button type="button" className="btn btn-secondary btn-lg">Large Button</button>
      <button type="button" className="btn btn-info btn-sm">Small Button</button>
      <button type="button" className="btn btn-secondary btn-sm">Small Button</button>
    </div>
             `}

                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Button Disabled State</h4>
                  <p className="card-title-desc">
                    Make buttons look inactive by adding the{" "}
                    <code>disabled</code> boolean attribute to any{" "}
                    <code>&lt;button&gt;</code> element. Disabled buttons have{" "}
                    <code>pointer-events: none</code> applied to, preventing
                    hover and active states from triggering.
                  </p>

                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled
                    >
                      Primary Button
                    </button>

                    <button
                      type="button"
                      className="btn btn-secondary"
                      disabled
                    >
                      Secondary
                    </button>
                  </div>

                  <div className="mt-3 border">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div>
    <button type="button" className="btn btn-primary" disabled>Primary Button</button>
    <button type="button" className="btn btn-secondary" disabled>Secondary</button>
  </div>
 `}

                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title">
                    Link Functionality Caveat Disable Buttons
                  </h4>
                  <p className="card-title-desc">
                    <code>&lt;a&gt;</code>s don't support the{" "}
                    <code>disabled</code> attribute, so you must add the{" "}
                    <code>.disabled</code> class and{" "}
                    <code>aria-disabled="true"</code> to make it visually
                    appear disabled. also include a <code>tabindex="-1"</code>{" "}
                    attribute.
                  </p>

                  <div className="d-flex flex-wrap gap-2">
                    <Link to="#"
                      className="btn btn-primary disabled"
                      role="button"
                      aria-disabled="true"
                    >
                      Primary link
                    </Link>
                    <Link to="#"
                      className="btn btn-secondary disabled"
                      role="button"
                      aria-disabled="true"
                    >
                      Link
                    </Link>
                  </div>

                  <div className="mt-3 border px-2">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div>
    <Link to="#" className="btn btn-primary disabled" role="button" aria-disabled="true">Primary link</Link>
    <Link to="#" className="btn btn-secondary disabled" role="button" aria-disabled="true">Link</Link>
  </div>
 `}
                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <div className="col-12">
              <Card>
                <CardBody>
                  <h4 className="card-title">Block Buttons</h4>
                  <p className="card-title-desc">
                    Create block level buttons—those that span the full width
                    of a parent—by adding <code>.d-grid</code>.
                  </p>

                  <div className="d-grid flex-wrap gap-2 align-items-center w-50">
                    <button
                      type="button"
                      className="btn btn-primary btn-lg"
                    >
                      Block level button
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                    >
                      Block level button
                    </button>
                  </div>

                  <div className="mt-3 border px-2">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div className="d-grid">
    <button type="button" className="btn btn-primary btn-lg">Block level button</button>
  </div>

   <div className="d-grid">
    <button type="button" className="btn btn-secondary btn-sm">Block level button</button>
  </div>
`}
                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </div>

            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Toggle States</h4>
                  <p className="card-title-desc">
                    Add <code>data-bs-toggle="button"</code>{" "}
                    to toggle a button's <code>active</code>{" "}
                    state. If you're pre-toggling a button, you must manually
                    add the <code>.active</code> class {" "}
                    <strong>and</strong> <code>aria-pressed="true"</code> to
                    the {" "}
                    <code>&lt;button&gt;</code>.
                  </p>

                  <div className="d-flex flex-wrap gap-3">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-toggle="button"
                      autoComplete="off"
                    >
                      Toggle Button
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary active"
                      data-bs-toggle="button"
                      autoComplete="off"
                      aria-pressed="true"
                    >
                      Active toggle Button
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled
                      data-bs-toggle="button"
                      autoComplete="off"
                    >
                      Disabled toggle Button
                    </button>
                  </div>

                  <div className="d-flex flex-wrap gap-2 mt-2">
                    <Link
                      to="#"
                      className="btn btn-primary"
                      role="button"
                      data-bs-toggle="button"
                    >
                      Toggle link
                    </Link>
                    <Link
                      to="#"
                      className="btn btn-primary active"
                      role="button"
                      data-bs-toggle="button"
                      aria-pressed="true"
                    >
                      Active Toggle link
                    </Link>
                    <Link
                      to="#"
                      className="btn btn-primary disabled"
                      aria-disabled="true"
                      role="button"
                      data-bs-toggle="button"
                    >
                      Disabled Toggle link
                    </Link>
                  </div>

                  <div className="mt-3 border px-2">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div>
    <button type="button" className="btn btn-primary" data-bs-toggle="button" autoComplete="off">Toggle Button</button>
    <button type="button" className="btn btn-primary active" data-bs-toggle="button" autoComplete="off" aria-pressed="true">Active toggle Button</button>
    <button type="button" className="btn btn-primary" disabled data-bs-toggle="button" autoComplete="off">Disabled toggle Button</button>
  </div>

  <div>
    <Link to="#" className="btn btn-primary" role="button" data-bs-toggle="button">Toggle link</Link>
    <Link to="#" className="btn btn-primary active" role="button" data-bs-toggle="button" aria-pressed="true">Active Toggle link</Link>
    <Link to="#" className="btn btn-primary disabled" aria-disabled="true" role="button" data-bs-toggle="button">Disabled Toggle link</Link>
  </div>

`}
                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Button Group</h4>
                  <p className="card-title-desc">
                    Wrap a series of buttons with <code>.btn</code> in{" "}
                    <code>.btn-group</code>.
                  </p>

                  <div className="d-flex flex-wrap gap-3 align-items-center">
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic example"
                    >
                      <button type="button" className="btn btn-primary">
                        Left
                      </button>
                      <button type="button" className="btn btn-primary">
                        Middle
                      </button>
                      <button type="button" className="btn btn-primary">
                        Right
                      </button>
                    </div>

                    <div className="btn-group">
                      <Link
                        to="#"
                        className="btn btn-primary active"
                        aria-current="page"
                      >
                        Active link
                      </Link>
                      <Link to="#" className="btn btn-primary">
                        Link
                      </Link>
                      <Link to="#" className="btn btn-primary">
                        Link
                      </Link>
                    </div>
                  </div>

                  <div className="mt-3 border px-2">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div className="d-flex flex-wrap gap-3 align-items-center">
    <div className="btn-group" role="group" aria-label="Basic example">
      <button type="button" className="btn btn-primary">Left</button>
      <button type="button" className="btn btn-primary">Middle</button>
      <button type="button" className="btn btn-primary">Right</button>
    </div>
    
    <div className="btn-group">
      <Link to="#" className="btn btn-primary active" aria-current="page">Active link</Link>
      <Link to="#" className="btn btn-primary">Link</Link>
      <Link to="#" className="btn btn-primary">Link</Link>
    </div>
  </div>
`}
                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Button Group Style</h4>
                  <p className="card-title-desc">
                    Wrap a series of buttons with Mixed Style and Outline
                    button
                  </p>

                  <div className="d-flex flex-wrap gap-3">
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic mixed styles example"
                    >
                      <button type="button" className="btn btn-danger">
                        Left
                      </button>
                      <button type="button" className="btn btn-warning">
                        Middle
                      </button>
                      <button type="button" className="btn btn-success">
                        Right
                      </button>
                    </div>

                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic outlined example"
                    >
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                      >
                        Left
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                      >
                        Middle
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                      >
                        Right
                      </button>
                    </div>
                  </div>

                  <div className="mt-3 border px-2">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
<div className="d-flex flex-wrap gap-3">
  <div className="btn-group" role="group" aria-label="Basic mixed styles example">
    <button type="button" className="btn btn-danger">Left</button>
    <button type="button" className="btn btn-warning">Middle</button>
    <button type="button" className="btn btn-success">Right</button>
  </div>
  
  <div className="btn-group" role="group" aria-label="Basic outlined example">
    <button type="button" className="btn btn-outline-primary">Left</button>
    <button type="button" className="btn btn-outline-primary">Middle</button>
    <button type="button" className="btn btn-outline-primary">Right</button>
  </div>
</div>

`}
                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Checkbox Buttons</h4>
                  <p className="card-title-desc">
                    Bootstrap's <code>.button</code> styles can be applied to
                    other elements, such as <code> &lt;label&gt;</code>s, to
                    provide checkbox style button toggling. Add{" "}
                    <code>data-bs-toggle="buttons"</code> to a {" "}
                    <code>.btn-group</code> containing those modified buttons
                    to enable toggling in their respective styles.
                  </p>

                  <div className="d-flex flex-wrap gap-3 align-items-start">
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic checkbox toggle button group"
                    >
                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck1"
                        autoComplete="off"
                      />
                      <label className="btn btn-primary" htmlFor="btncheck1">
                        Checkbox 1
                      </label>

                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck2"
                        autoComplete="off"
                      />
                      <label className="btn btn-primary" htmlFor="btncheck2">
                        Checkbox 2
                      </label>

                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck3"
                        autoComplete="off"
                      />
                      <label className="btn btn-primary" htmlFor="btncheck3">
                        Checkbox 3
                      </label>
                    </div>

                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic checkbox toggle button group"
                    >
                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck4"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="btncheck4"
                      >
                        Checkbox 4
                      </label>

                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck5"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="btncheck5"
                      >
                        Checkbox 5
                      </label>

                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck6"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="btncheck6"
                      >
                        Checkbox 6
                      </label>
                    </div>
                  </div>

                  <div className="d-flex flex-wrap gap-3 align-items-start mt-2">
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic checkbox toggle button group"
                    >
                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck7"
                        autoComplete="off"
                      />
                      <label className="btn btn-primary" htmlFor="btncheck7">
                        <i className="mdi mdi-microphone"></i> Singing
                      </label>

                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck8"
                        autoComplete="off"
                      />
                      <label className="btn btn-primary" htmlFor="btncheck8">
                        <i className="mdi mdi-book-open"></i> Reading
                      </label>

                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck9"
                        autoComplete="off"
                      />
                      <label className="btn btn-primary" htmlFor="btncheck9">
                        <i className="mdi mdi-gamepad-variant-outline"></i>{" "}
                        Playing
                      </label>
                    </div>

                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic checkbox toggle button group"
                    >
                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck10"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="btncheck10"
                      >
                        <i className="mdi mdi-microphone"></i> Singing
                      </label>

                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck11"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="btncheck11"
                      >
                        <i className="mdi mdi-book-open"></i> Reading
                      </label>

                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck12"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="btncheck12"
                      >
                        <i className="mdi mdi-gamepad-variant-outline"></i>{" "}
                        Playing
                      </label>
                    </div>
                  </div>

                  <div className="mt-3 border px-2">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div className="d-flex flex-wrap gap-3 align-items-start">
    <div className="btn-group" role="group" aria-label="Basic checkbox toggle button group">
      <input type="checkbox" className="btn-check" id="btncheck1" autoComplete="off" />
      <label className="btn btn-primary" htmlFor="btncheck1">Checkbox 1</label>

      <input type="checkbox" className="btn-check" id="btncheck2" autoComplete="off" />
      <label className="btn btn-primary" htmlFor="btncheck2">Checkbox 2</label>

      <input type="checkbox" className="btn-check" id="btncheck3" autoComplete="off" />
      <label className="btn btn-primary" htmlFor="btncheck3">Checkbox 3</label>
    </div>
    
    <div className="btn-group" role="group" aria-label="Basic checkbox toggle button group">
      <input type="checkbox" className="btn-check" id="btncheck4" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="btncheck4">Checkbox 4</label>

      <input type="checkbox" className="btn-check" id="btncheck5" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="btncheck5">Checkbox 5</label>

      <input type="checkbox" className="btn-check" id="btncheck6" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="btncheck6">Checkbox 6</label>
    </div>
  </div>

  <div className="d-flex flex-wrap gap-3 align-items-start mt-2">
    <div className="btn-group" role="group" aria-label="Basic checkbox toggle button group">
      <input type="checkbox" className="btn-check" id="btncheck7" autoComplete="off" />
      <label className="btn btn-primary" htmlFor="btncheck7"><i className="mdi mdi-microphone"></i> Singing</label>

      <input type="checkbox" className="btn-check" id="btncheck8" autoComplete="off" />
      <label className="btn btn-primary" htmlFor="btncheck8"><i className="mdi mdi-book-open"></i> Reading</label>

      <input type="checkbox" className="btn-check" id="btncheck9" autoComplete="off" />
      <label className="btn btn-primary" htmlFor="btncheck9"><i className="mdi mdi-gamepad-variant-outline"></i> Playing</label>
    </div>
    
    <div className="btn-group" role="group" aria-label="Basic checkbox toggle button group">
      <input type="checkbox" className="btn-check" id="btncheck10" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="btncheck10"><i className="mdi mdi-microphone"></i> Singing</label>

      <input type="checkbox" className="btn-check" id="btncheck11" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="btncheck11"><i className="mdi mdi-book-open"></i> Reading</label>

      <input type="checkbox" className="btn-check" id="btncheck12" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="btncheck12"><i className="mdi mdi-gamepad-variant-outline"></i> Playing</label>
    </div>
  </div>

`}
                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Radio Buttons</h4>
                  <p className="card-title-desc">
                    Bootstrap's <code>.button</code> styles can be applied to
                    other elements, such as <code> &lt;label&gt;</code>s, to
                    provide radio style button toggling. Add{" "}
                    <code>data-bs-toggle="buttons"</code> to a {" "}
                    <code>.btn-group</code> containing those modified buttons
                    to enable toggling in their respective styles.
                  </p>

                  <div className="d-flex flex-wrap gap-3">
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic radio toggle button group"
                    >
                      <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id="btnradio1"
                        autoComplete="off"
                        defaultChecked
                      />
                      <label className="btn btn-primary" htmlFor="btnradio1">
                        Radio 1
                      </label>

                      <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id="btnradio2"
                        autoComplete="off"
                      />
                      <label className="btn btn-primary" htmlFor="btnradio2">
                        Radio 2
                      </label>

                      <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id="btnradio3"
                        autoComplete="off"
                      />
                      <label className="btn btn-primary" htmlFor="btnradio3">
                        Radio 3
                      </label>
                    </div>

                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic radio toggle button group"
                    >
                      <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id="btnradio4"
                        autoComplete="off"
                        defaultChecked
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="btnradio4"
                      >
                        Radio 4
                      </label>

                      <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id="btnradio5"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="btnradio5"
                      >
                        Radio 5
                      </label>

                      <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id="btnradio6"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="btnradio6"
                      >
                        Radio 6
                      </label>
                    </div>
                  </div>

                  <div className="d-flex flex-wrap gap-3 mt-2">
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic radio toggle button group"
                    >
                      <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id="btnradioMale"
                        autoComplete="off"
                        defaultChecked
                      />
                      <label className="btn btn-primary" htmlFor="btnradioMale">
                        <i className="mdi mdi-human-male"></i> Male
                      </label>

                      <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id="btnradioFemale"
                        autoComplete="off"
                      />
                      <label className="btn btn-primary" htmlFor="btnradioFemale">
                        <i className="mdi mdi-human-female"></i> Female
                      </label>
                    </div>

                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic radio toggle button group"
                    >
                      <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id="align-left"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="align-left"
                      >
                        <i className="mdi mdi-format-align-left"></i>
                      </label>

                      <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id="align-center"
                        autoComplete="off"
                        defaultChecked
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="align-center"
                      >
                        <i className="mdi mdi-format-align-center"></i>
                      </label>

                      <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id="align-right"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="align-right"
                      >
                        <i className="mdi mdi-format-align-right"></i>
                      </label>
                    </div>
                  </div>

                  <div className="mt-3 border px-2">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div className="d-flex flex-wrap gap-3">
    <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
      <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off" defaultChecked />
      <label className="btn btn-primary" htmlFor="btnradio1">Radio 1</label>

      <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off" />
      <label className="btn btn-primary" htmlFor="btnradio2">Radio 2</label>

      <input type="radio" className="btn-check" name="btnradio" id="btnradio3" autoComplete="off" />
      <label className="btn btn-primary" htmlFor="btnradio3">Radio 3</label>
    </div>
    
    <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
      <input type="radio" className="btn-check" name="btnradio" id="btnradio4" autoComplete="off" defaultChecked />
      <label className="btn btn-outline-primary" htmlFor="btnradio4">Radio 4</label>

      <input type="radio" className="btn-check" name="btnradio" id="btnradio5" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="btnradio5">Radio 5</label>

      <input type="radio" className="btn-check" name="btnradio" id="btnradio6" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="btnradio6">Radio 6</label>
    </div>
  </div>

  <div className="d-flex flex-wrap gap-3 mt-2">
    <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
      <input type="radio" className="btn-check" name="btnradio" id="btnradioMale" autoComplete="off" defaultChecked />
      <label className="btn btn-primary" htmlFor="btnradioMale"><i className="mdi mdi-human-male"></i> Male</label>

      <input type="radio" className="btn-check" name="btnradio" id="btnradioFemale" autoComplete="off" />
      <label className="btn btn-primary" htmlFor="btnradioFemale"><i className="mdi mdi-human-female"></i> Female</label>
    </div>
    
    <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
      <input type="radio" className="btn-check" name="btnradio" id="align-left" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="align-left"><i className="mdi mdi-format-align-left"></i></label>

      <input type="radio" className="btn-check" name="btnradio" id="align-center" autoComplete="off" defaultChecked />
      <label className="btn btn-outline-primary" htmlFor="align-center"><i className="mdi mdi-format-align-center"></i></label>

      <input type="radio" className="btn-check" name="btnradio" id="align-right" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="align-right"><i className="mdi mdi-format-align-right"></i></label>
    </div>
  </div>

`}
                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Button Toolbar</h4>
                  <p className="card-title-desc">
                    Wrap a series of buttons with <code>.btn</code> in{" "}
                    <code>.btn-group</code>.
                  </p>

                  <div className="d-flex flex-wrap gap-3 align-items-center">
                    <div
                      className="btn-toolbar"
                      role="toolbar"
                      aria-label="Toolbar with button groups"
                    >
                      <div
                        className="btn-group me-2"
                        role="group"
                        aria-label="First group"
                      >
                        <button type="button" className="btn btn-primary">
                          1
                        </button>
                        <button type="button" className="btn btn-primary">
                          2
                        </button>
                        <button type="button" className="btn btn-primary">
                          3
                        </button>
                        <button type="button" className="btn btn-primary">
                          4
                        </button>
                      </div>
                      <div
                        className="btn-group me-2"
                        role="group"
                        aria-label="Second group"
                      >
                        <button type="button" className="btn btn-secondary">
                          5
                        </button>
                        <button type="button" className="btn btn-secondary">
                          6
                        </button>
                        <button type="button" className="btn btn-secondary">
                          7
                        </button>
                      </div>

                    </div>
                  </div>

                  <div className="mt-3 border px-2">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div className="d-flex flex-wrap gap-3 align-items-center">
    <div className="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
      <div className="btn-group me-2" role="group" aria-label="First group">
        <button type="button" className="btn btn-primary">1</button>
        <button type="button" className="btn btn-primary">2</button>
        <button type="button" className="btn btn-primary">3</button>
        <button type="button" className="btn btn-primary">4</button>
      </div>

      <div className="btn-group me-2" role="group" aria-label="Second group">
        <button type="button" className="btn btn-secondary">5</button>
        <button type="button" className="btn btn-secondary">6</button>
        <button type="button" className="btn btn-secondary">7</button>
      </div>
    </div>
  </div>

`}
                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Nesting</h4>
                  <p className="card-title-desc">
                    Place a <code>.btn-group</code> within another{" "}
                    <code>.btn-group</code> when you want dropdown menus mixed
                    with a series of buttons.
                  </p>

                  <div
                    className="btn-group"
                    role="group"
                    aria-label="Button group with nested dropdown"
                  >
                    <button type="button" className="btn btn-primary">
                      1
                    </button>
                    <button type="button" className="btn btn-primary">
                      2
                    </button>

                    <div className="btn-group" role="group">
                      <ButtonDropdown
                        isOpen={drp_link1}
                        toggle={() => {
                          setdrp_link1(!drp_link1);
                        }}
                      >
                        <DropdownToggle caret color="primary">
                          Dropdown <i className="mdi mdi-chevron-down"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem>Dropdown link</DropdownItem>
                          <DropdownItem>Dropdown link</DropdownItem>
                        </DropdownMenu>
                      </ButtonDropdown>
                    </div>
                  </div>

                  <div className="mt-3 border px-2">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
    <button type="button" className="btn btn-primary">1</button>
    <button type="button" className="btn btn-primary">2</button>

    <div className="btn-group" role="group">
      <ButtonDropdown isOpen={drp_link1} toggle={() => setdrp_link1(!drp_link1)}>
        <DropdownToggle caret color="primary">
          Dropdown <i className="mdi mdi-chevron-down"></i>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem>Dropdown link</DropdownItem>
          <DropdownItem>Dropdown link</DropdownItem>
        </DropdownMenu>
      </ButtonDropdown>
    </div>
  </div>

`}
                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Button Group Size</h4>
                  <p className="card-title-desc">
                    Instead of applying button sizing classes to every button
                    in a group, just add {" "}
                    <code>.btn-group-*</code> to each <code>.btn-group</code>,
                    including each one when nesting multiple groups.
                  </p>

                  <div className="d-flex flex-row align-items-center gap-3">
                    <div
                      className="btn-group btn-group-lg"
                      role="group"
                      aria-label="Large button group"
                    >
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                      >
                        Left
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                      >
                        Middle
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                      >
                        Right
                      </button>
                    </div>

                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Default button group"
                    >
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                      >
                        Left
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                      >
                        Middle
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                      >
                        Right
                      </button>
                    </div>

                  </div>

                  <div className="mt-3 border px-2">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div className="d-flex flex-row align-items-center gap-3">
    <div className="btn-group btn-group-lg" role="group" aria-label="Large button group">
      <button type="button" className="btn btn-outline-primary">Left</button>
      <button type="button" className="btn btn-outline-primary">Middle</button>
      <button type="button" className="btn btn-outline-primary">Right</button>
    </div>

    <div className="btn-group" role="group" aria-label="Default button group">
      <button type="button" className="btn btn-outline-secondary">Left</button>
      <button type="button" className="btn btn-outline-secondary">Middle</button>
      <button type="button" className="btn btn-outline-secondary">Right</button>
    </div>
  </div>

`}
                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">Vertical Variation</h4>
                  <p className="card-title-desc">
                    Make a set of buttons appear vertically stacked rather
                    than horizontally.{" "}
                    <b>Split button dropdowns are not supported here.</b>
                    <br />
                    use this class name<b> : btn-group-vertical</b>
                  </p>

                  <div className="d-flex flex-wrap gap-4 align-items-end">
                    <div
                      className="btn-group-vertical"
                      role="group"
                      aria-label="Vertical button group"
                    >
                      <button type="button" className="btn btn-secondary">
                        Button
                      </button>
                      <button type="button" className="btn btn-secondary">
                        Button
                      </button>
                      <button type="button" className="btn btn-secondary">
                        Button
                      </button>
                    </div>



                    <div
                      className="btn-group-vertical"
                      role="group"
                      aria-label="Vertical button group"
                    >
                      <button type="button" className="btn btn-secondary">
                        Button
                      </button>
                      <div className="btn-group" role="group">
                        <ButtonDropdown
                          isOpen={drp_link}
                          toggle={() => {
                            setdrp_link(!drp_link);
                          }}
                        >
                          <DropdownToggle caret color="secondary">
                            Dropdown <i className="mdi mdi-chevron-down"></i>
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem>Dropdown link</DropdownItem>
                            <DropdownItem>Dropdown link</DropdownItem>
                          </DropdownMenu>
                        </ButtonDropdown>
                      </div>

                      <button type="button" className="btn btn-secondary">
                        Button
                      </button>
                    </div>


                    <div
                      className="btn-group-vertical"
                      role="group"
                      aria-label="Vertical radio toggle button group"
                    >
                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck13"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="btncheck13"
                      >
                        <i className="mdi mdi-microphone"></i> Singing
                      </label>

                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck14"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="btncheck14"
                      >
                        <i className="mdi mdi-book-open"></i> Reading
                      </label>

                      <input
                        type="checkbox"
                        className="btn-check"
                        id="btncheck15"
                        autoComplete="off"
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="btncheck15"
                      >
                        <i className="mdi mdi-gamepad-variant-outline me-1"></i>
                        Playing
                      </label>
                    </div>
                  </div>

                  <div className="mt-3 border px-2">
                    <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                      <code>
                        {`
  <div className="d-flex flex-wrap gap-4 align-items-end">
    <div className="btn-group-vertical" role="group" aria-label="Vertical button group">
      <button type="button" className="btn btn-secondary">Button</button>
      <button type="button" className="btn btn-secondary">Button</button>
      <button type="button" className="btn btn-secondary">Button</button>
    </div>

    <div className="btn-group-vertical" role="group" aria-label="Vertical button group">
      <button type="button" className="btn btn-secondary">Button</button>
      <div className="btn-group" role="group">
        <ButtonDropdown
          isOpen={drp_link}
          toggle={() => setdrp_link(!drp_link)}
        >
          <DropdownToggle caret color="secondary">
            Dropdown <i className="mdi mdi-chevron-down"></i>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem>Dropdown link</DropdownItem>
            <DropdownItem>Dropdown link</DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
      </div>
      <button type="button" className="btn btn-secondary">Button</button>
    </div>

    <div className="btn-group-vertical" role="group" aria-label="Vertical checkbox toggle button group">
      <input type="checkbox" className="btn-check" id="btncheck13" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="btncheck13">
        <i className="mdi mdi-microphone"></i> Singing
      </label>

      <input type="checkbox" className="btn-check" id="btncheck14" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="btncheck14">
        <i className="mdi mdi-book-open"></i> Reading
      </label>

      <input type="checkbox" className="btn-check" id="btncheck15" autoComplete="off" />
      <label className="btn btn-outline-primary" htmlFor="btncheck15">
        <i className="mdi mdi-gamepad-variant-outline me-1"></i> Playing
      </label>
    </div>
  </div>

`}
                      </code>
                    </pre>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UiButtons;
